export default "__VITE_ASSET__DUers586__"